<template>
  <div class="invite-activity">
    <InviteActivitySection1 />

    <InviteActivitySection2 />

    <!-- <InviteActivitySection3 :address="ownerAddress" :inviteCode="inviteCode" /> -->

    <!-- <InviteActivitySection4 /> -->
  </div>
</template>
<script>
import api from "@/service/api";
import InviteActivitySection1 from "@/components/inviteActivity/Section1.vue";
import InviteActivitySection2 from "@/components/inviteActivity/Section2.vue";
// import InviteActivitySection1 from "@/components/inviteActivity/InviteActivitySection1.vue";
// import InviteActivitySection2 from "@/components/inviteActivity/InviteActivitySection2.vue";
// import InviteActivitySection3 from "@/components/inviteActivity/InviteActivitySection3.vue";
// import InviteActivitySection4 from "@/components/inviteActivity/InviteActivitySection4.vue";

export default {
  data() {
    return {
      ownerAddress: "",
      inviteCode: "",
    };
  },
  components: {
    InviteActivitySection1,
    InviteActivitySection2,
    // InviteActivitySection3,
    // InviteActivitySection4,
  },
  methods: {
    async getQueryAddressByUserCode() {
      const queryAddressByUserCodeData = await api["queryAddressByUserCode"]({
        inviteCode: this.inviteCode,
      });

      this.ownerAddress = queryAddressByUserCodeData.ownerAddress;

      console.log("queryAddressByUserCodeData", queryAddressByUserCodeData);
    },
  },
  async created() {
    this.inviteCode = this.$route.query.InviteCode;

    await this.getQueryAddressByUserCode();
  },
};
</script>
<style lang="scss" scoped>
.invite-activity {
  background: #fff;
  padding-bottom: 40px;
}
</style>
<style lang="scss">
.invite-activity-container {
  padding: 30px 15px 0;
}

.invite-activity {
  .icon {
    display: inline-block;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
  }

  .icon-addr {
    margin-right: 20px;
    width: 24px;
    height: 24px;
    background-image: url("../assets/images/inviteActivity/addr-icon.svg");
  }
}
</style>
